export const isHTMLStringEmpty = (htmlString: string) =>
  !htmlString.replace(/<[^>]*>/g, '').trim();

export const addUnderlineToLink = (htmlString: string) =>
  htmlString.replace(/<a/gi, '<a style="text-decoration: underline;"');

const BLOCKED_TAGS = [
  'script',
  'iframe',
  'object',
  'embed',
  'form',
  'link',
  'meta',
  'style',
  'base',
  'applet',
  'frame',
  'frameset',
];

export const sanitizeHtml = (html: string): string =>
  html
    .replace(new RegExp(`</?(?:${BLOCKED_TAGS.join('|')})\\b[^>]*>`, 'gi'), '')
    .replace(/\son\w+\s*=\s*(".*?"|'.*?'|[^\s>]*)/gi, '')
    .replace(/((?:href|src)\s*=\s*)(["']?)\s*javascript:[^"'>]*\2/gi, '$1$2$2');

export const validateEmail = (email) => {
  if (email.trim().length === 0) {
    return false;
  }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
